import Questionnaire from './Questionnaire';

export default Questionnaire;